import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.css']
})
export class PaymentResultComponent {

  title = "Payment Successful!"
  message = "Thanks for subscribing! You can now start using Rank Ahead with all the available features in your plan."

  constructor(@Inject(DOCUMENT) private document: Document, private titleService: Title, private route: ActivatedRoute) {
    this.titleService.setTitle("Payment Result | RankAhead");
  }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');

    let type = this.route.snapshot.paramMap.get('type');

    if (type == "2") { // Change plan
      this.title = "You have switched to a new plan.";
      this.message = "You can continue using Rank Ahead with all the available features in your new plan.";
    }
    else if (type == "3") { // Cancel plan
      this.title = "You have canceled your subscription.";
      this.message = "You are now downgraded to free Starter plan.";
    }
  }
}
